

















































































































































































































































































































































































































































































































































































































import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import Http from "@/mixins/http";
import Toast from "@/mixins/toast";
import MarketSelect from "@/components/MarketSelect.vue";
import Card from "@/components/UI/Card.vue";
import moment from "moment";

import {
    FixedPriceItem,
    FixedPriceParams,
    FixedPriceSelectedItems,
    FileType,
} from "@/interfaces/server-data";
import {SelectBox, SelectMarket} from "@/interfaces/global-data";
import Files from '@/components/Files.vue';
import dayjs from "dayjs";
import DatePicker from "@/components/UI/DatePicker.vue";
import ColumnTitleContent from '@/components/UI/Table/ColumnTitleContent.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';

interface ITableFilterValues {
    regularPriceStartDate: string | null,
    regularPriceEndDate: string | null,
    fileUploadDate: string | null,
    regularPrices: number[],
    userName: string | null,
}

@Component({
  components: {
    Files,
    MarketSelect,
    Card,
    DatePicker,
    ColumnTitleContent,
    SwitchWithLabel,
  },
})
export default class FixedPricesView extends Mixins(Http, Toast) {
  @Prop({required: true}) readonly selectMarket!: SelectMarket;

  dateRange: string[] = this.getDateRange() ? JSON.parse(this.getDateRange()) : [dayjs().subtract(7, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')];

  currentMainTab: string = "viewFixedPrices";

  selectedItems: FixedPriceSelectedItems[] = [];

  fixedPricesItems: FixedPriceItem[] = [];

  selectSkuName: string | null = null

  uploadFileIdFilterValue: number | null = null;
  uploadFileFilterOptions: Array<SelectBox<number>> = [];

  selectCodeSalesPoint: string | null = null

  selectInternalCode: string | null = null

  tableFilterValues: ITableFilterValues = {
      regularPriceStartDate: null,
      regularPriceEndDate: null,
      fileUploadDate: null,
      regularPrices: [],
      userName: null,
  };

  defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};
  secondDefaultFilterValue = {value: -2, label: this.$t('shared.selectBox.notSelected') as string};
  defaultMultipleValue = [this.defaultFilterValue, this.secondDefaultFilterValue];

  selectGroupIds: number[] = [];
  groupOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

  selectCategoryIds: number[] = [];
  categoryOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

  selectSubcategoryIds: number[] = [];
  subcategoryOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

  selectRegionIds: number[] = [];
  regionOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

  selectStoreIds: number[] = [];
  storeOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

  selectClusterIds: number[] = [];
  storeClusterOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

  showDeletedRows: boolean = false;

  isRangeNotSelected: boolean = false;

  isCommonCheckboxSelected: boolean = false;
  includedSkus: any[] = [];
  excludedSkuIds: number[] = [];

  tableIsLoading: boolean = false;
  isStartCalcLoading: boolean = false;
  pagination: any = {
    current: 1,
    pageSize: 20,
    total: 0,
    totalActiveElements: 0,
    position: 'bottom',
    showSizeChanger: true,
    pageSizeOptions: ['20', '30', '40', '50', '100'],
  };

  filterDropdownsRange: any = {
      from: {},
      to: {},
  };
  tableFilterOptions: any = {};
  filterAllCheckboxCheckedState: any = {};

  fixedPricesTableFields: any[] = [
    {
        key: 'checkboxes',
        scopedSlots: {
            title: 'commonCheckbox',
            customRender: 'rowCheckbox',
        },
        width: 50
    },
    {
        key: 'isActive',
        dataIndex: 'isActive',
        slots: { title: 'isActiveColumnTitle' }, // dataIndex + 'ColumnTitle'
        slotColumnTitleData: {
            text: this.$t('fixedPrices.view.productActivity') as string,
        },
        scopedSlots: { customRender: 'isActive' },
        width: 126,
        ellipsis: true,
        align: 'center',
    },
    {
        key: 'internalCode',
        dataIndex: 'internalCode',
        slots: { title: 'internalCodeColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('fixedPrices.view.productInternalCode') as string,
        },
        scopedSlots: {
            customRender: 'internalCode',
            filterDropdown: 'internalCodeFilter',
            filterIcon: "internalCodeFilterIcon"
        },
        width: 160,
        ellipsis: true,
    },
    {
        key: 'skuName',
        dataIndex: 'skuName',
        slots: { title: 'skuNameColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('fixedPrices.view.productName') as string,
        },
        // ellipsis: true,
        width: 240,
        scopedSlots: {
            filterDropdown: 'skuNameFilter',
            filterIcon: "skuNameFilterIcon"
        },
    },
    {
      key: 'groupName',
      dataIndex: 'groupName',
      slots: { title: 'groupNameColumnTitle' },
      slotColumnTitleData: {
            text: this.$t('shared.filters.group') as string,
      },
      // ellipsis: true,
      width: 240,
      scopedSlots: {
        customRender: 'groupName',
        filterDropdown: 'groupNameFilter',
        filterIcon: "groupNameFilterIcon"
      },
    },
    {
      key: 'categoryName',
      dataIndex: 'categoryName',
      slots: { title: 'categoryNameColumnTitle' },
      slotColumnTitleData: {
            text: this.$t('shared.filters.category') as string,
      },
      // ellipsis: true,
      width: 240,
      scopedSlots: {
        customRender: 'categoryName',
        filterDropdown: 'categoryNameFilter',
        filterIcon: 'categoryNameFilterIcon'
      },
    },
    {
      key: 'subcategoryName',
      dataIndex: 'subcategoryName',
      slots: { title: 'subcategoryNameColumnTitle' },
      slotColumnTitleData: {
            text: this.$t('shared.filters.subcategory') as string,
      },
      // ellipsis: true,
      width: 240,
      scopedSlots: {
        customRender: 'subcategoryName',
        filterDropdown: 'subcategoryNameFilter',
        filterIcon: 'subcategoryNameFilterIcon'
      },
    },
    {
        key: 'codeSalesPoint',
        dataIndex: 'codeSalesPoint',
        slots: { title: 'codeSalesPointColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('fixedPrices.view.salesPointCode') as string,
        },
        scopedSlots: {
            customRender: 'codeSalesPoint',
            filterDropdown: 'codeSalesPointFilter',
            filterIcon: "codeSalesPointFilterIcon"
        },
        width: 150,
        ellipsis: true,
    },
    {
        key: 'storeRegion',
        dataIndex: 'storeRegion',
        slots: { title: 'storeRegionColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('shared.filters.region') as string,
        },
        scopedSlots: { filterDropdown: 'regionFilter', filterIcon: "regionFilterIcon" },
        width: 120,
        ellipsis: true,
    },
    {
        key: 'storeFormat',
        dataIndex: 'storeFormat',
        slots: { title: 'storeFormatColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('shared.labels.storeFormat') as string,
        },
        scopedSlots: { filterDropdown: 'storeFilter', filterIcon: "storeFilterIcon" },
        width: 134,
        ellipsis: true,
    },
    {
      key: 'storeCluster',
      dataIndex: 'storeCluster',
      slots: { title: 'storeClusterColumnTitle' },
      slotColumnTitleData: {
            text: this.$t('shared.filters.cluster') as string,
      },
      scopedSlots: { filterDropdown: 'clusterFilter', filterIcon: 'clusterFilterIcon' },
      width: 120,
      ellipsis: true,
    },
    {
        key: 'regularPrice',
        dataIndex: 'regularPrice',
        slots: { title: 'regularPriceColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('fixedPrices.view.regularPriceCol') as string,
        },
        filterModelKey: 'regularPrices',
        filterOptionsKey: 'regularPrices',
        showRange: true,
        scopedSlots: {
          customRender: 'regularPrice',
          filterDropdown: 'filterCheckboxes',
          filterIcon: "filterIcon",
        },
        width: 170,
        ellipsis: true,
    },
    {
        key: 'promoPrice',
        dataIndex: 'promoPrice',
        slots: { title: 'promoPriceColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('fixedPrices.view.promoPriceCol') as string,
        },
        scopedSlots: {
          customRender: 'promoPrice',
          filterDropdown: 'promoPriceFilter',
          filterIcon: "promoPriceFilterIcon"
        },
        width: 130,
        ellipsis: true,
    },
    {
        key: 'regularPriceStartDate',
        dataIndex: 'regularPriceStartDate',
        slots: { title: 'regularPriceStartDateColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('fixedPrices.view.regularPriceStartDate') as string,
        },
        filterModelKey: 'regularPriceStartDate',
        scopedSlots: {
            customRender: 'regularPriceStartDate',
            filterDropdown: 'filterDatepicker',
            filterIcon: "filterIcon"
        },
        width: 164,
        ellipsis: true,
    },
    {
        key: 'regularPriceEndDate',
        dataIndex: 'regularPriceEndDate',
        slots: { title: 'regularPriceEndDateColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('fixedPrices.view.regularPriceEndDate') as string,
        },
        filterModelKey: 'regularPriceEndDate',
        scopedSlots: {
            customRender: 'regularPriceEndDate',
            filterDropdown: 'filterDatepicker',
            filterIcon: "filterIcon"
        },
        width: 190,
        ellipsis: true,
    },
    {
        key: 'promoPriceStartDate',
        dataIndex: 'promoPriceStartDate',
        slots: { title: 'promoPriceStartDateColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('fixedPrices.view.promoPriceStartDate') as string,
        },
        scopedSlots: { customRender: 'promoPriceStartDate' },
        width: 172,
        ellipsis: true,
    },
    {
        key: 'promoPriceEndDate',
        dataIndex: 'promoPriceEndDate',
        slots: { title: 'promoPriceEndDateColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('fixedPrices.view.promoPriceEndDate') as string,
        },
        scopedSlots: { customRender: 'promoPriceEndDate' },
        width: 180,
        ellipsis: true,
    },
    {
        key: 'uploadFile',
        dataIndex: 'uploadFile',
        slots: { title: 'uploadFileColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('fixedPrices.view.uploadFile') as string,
        },
        scopedSlots: {
            filterDropdown: 'fileFilter',
            filterIcon: 'fileFilterIcon',
        },
        width: 160,
        ellipsis: true,
    },
    {
        key: 'fileUploadDate',
        dataIndex: 'fileUploadDate',
        slots: { title: 'fileUploadDateColumnTitle' },
        slotColumnTitleData: {
            text: this.$t('shared.labels.fileUploadDate') as string,
        },
        filterModelKey: 'fileUploadDate',
        scopedSlots: {
            filterDropdown: 'filterDatepicker',
            filterIcon: "filterIcon",
        },
        width: 158,
        ellipsis: true,
    },
    {
      key: 'username',
      dataIndex: 'username',
      slots: { title: 'usernameColumnTitle' },
      slotColumnTitleData: {
            text: this.$t('shared.labels.user') as string,
      },
      filterModelKey: 'userName',
      filterOptionsKey: 'usersFilterOptions',
      scopedSlots: {
          customRender: 'username',
          filterDropdown: 'filterRadioButtons',
          filterIcon: "filterIcon",
      },
      width: 150,
      ellipsis: true,
    },
  ];

  mounted() {
    this.dateRange = [
      dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      dayjs().format('YYYY-MM-DD')
    ];
    this.fetchFixedPrices();
    this.fetchFilterOptions();
  }

  @Watch("selectMarket", {deep: true})
  handleSelectMarketUpdated() {
      this.fetchFilterOptions();
    // Update filters when market changes
      this.fetchFixedPrices(1); // Fetch prices based on the new market
  }

  handleTableChange(pagination: any, filters: any, sorter: any) {
    this.pagination.current = pagination.current;
    this.pagination.pageSize = pagination.pageSize;

    this.fetchFixedPrices(); // Fetch new data based on updated pagination
    // this.fetchFilterOptions();
  }

  fetchFilterOptions() {
    if (!this.selectMarket) {
      return;
    }

    this.httpGetFixedPricesFilterOptions(this.selectMarket.id, this.dateRange[0], this.dateRange[1])
        .then((r) => {

          this.groupOptions = r.data.groups.map(item => {
            return {
              value: item.id,
              label: item.name
            };
          }).sort((a, b) => a.label.localeCompare(b.label));

          this.categoryOptions = r.data.categories.map(item => {
            return {
              value: item.id,
              label: item.name
            };
          }).sort((a, b) => a.label.localeCompare(b.label));

          this.subcategoryOptions = r.data.subcategories.map(item => {
            return {
              value: item.id,
              label: item.name
            };
          }).sort((a, b) => a.label.localeCompare(b.label));

          this.regionOptions = r.data.storeRegions.map(item => {
            return {
              value: item.id,
              label: item.name
            };
          }).sort((a, b) => a.label.localeCompare(b.label));

        this.storeOptions = r.data.storeFormats.map(item => {
          return {
            value: item.id,
            label: item.name
          };
        }).sort((a, b) => a.label.localeCompare(b.label));

        this.storeClusterOptions = r.data.storeClusters.map(item => {
          return {
            value: item.id,
            label: item.name
          };
        }).sort((a, b) => a.label.localeCompare(b.label));

          this.tableFilterOptions.regularPrices = (r.data.regularPrices || [])
              .map(el => ({ label: String(el), value: el }))
              .sort((a, b) => a.value - b.value);
      });

      this.httpGetFileList({
          type: FileType.FIXED_PRICE,
          size: 10000,
          page: 0,
      })
          .then((response: any) => {
              this.uploadFileFilterOptions = response.data.content.map(({id, filePath}: {id: number, filePath: string}) => ({value: id, label: filePath}));
          })
          .catch(() => {
              this.showError(this.$t('shared.messages.errorLoadFileList') as string);
          });

      if (!this.tableFilterOptions.usersFilterOptions || !this.tableFilterOptions.usersFilterOptions.length) {
          this.httpGetUsersFio()
              .then((response) => {
                  this.tableFilterOptions.usersFilterOptions = response.data.map((i) => {
                      return {value: i, label: i}
                  });
              })
              .catch(() => {
                  this.showError(this.$t('shared.messages.errorLoadUserList') as string);
              });
      }
  }

  fetchFixedPrices(currentPage?: number) {
    if (currentPage) {
        this.pagination.current = currentPage;
    }

    if (this.selectMarket && !this.isRangeNotSelected) {
      this.tableIsLoading = true;

      const params = this.filterParams();
      this.httpGetFixedPrices(params)
          .then(response => {
            if (response && response.data) {
              this.fixedPricesItems = response.data.content;
              this.pagination.total = response.data.totalElements;
              this.pagination.totalActiveElements = response.data.totalActiveElements || response.data.totalElements;
            }
          })
          .finally(() => {
            this.tableIsLoading = false;
          });
    }
  }

  async fetchFileExport() {
    if (this.selectMarket && !this.isRangeNotSelected) {
      this.tableIsLoading = true;

      const params = this.filterParams();
      params.selectedIds = this.includedSkus.map(sku => sku.id)

      this.httpGetFixedPricesFile(params)
          .then((response) => {
            let dateString = moment().format('YYYYMMDD_HHmmss')
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                this.$t('fixedPrices.view.exportFileName') as string + '_' + dateString + '.csv'
            );

            document.body.appendChild(link);
            link.click();
          })
          .finally(() => {
            this.tableIsLoading = false;
          });
    }
  }

  handleTableFilterDateSelected(filterModelKey: string) {
      this.applyFilters();
  }

  uploadFileSearchFilterOption(input: string, option: any) {
      return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
  }


  applyFilters() {
    this.fetchFixedPrices(1);
    // this.fetchFilterOptions();
  }

  filterParams(): FixedPriceParams {
    return {
      tradingNetId: this.selectMarket ? this.selectMarket.id : -1,
      page: this.pagination.current - 1,
      size: this.pagination.pageSize,
      skuName: !!this.selectSkuName ? this.selectSkuName : null,
      uploadFileIdFilterValue: !!this.uploadFileIdFilterValue || this.uploadFileIdFilterValue === 0 ? this.uploadFileIdFilterValue : null,
      codeSalesPoint: !!this.selectCodeSalesPoint ? this.selectCodeSalesPoint : null,
      internalCode: !!this.selectInternalCode ? this.selectInternalCode : null,
      storeRegionIds: this.selectRegionIds,
      storeFormatIds: this.selectStoreIds,
      storeClusterIds: this.selectClusterIds,
      dateBefore: this.dateRange[1],
      dateAfter: this.dateRange[0],
      regularPriceStartDate: this.tableFilterValues.regularPriceStartDate,
      regularPriceEndDate: this.tableFilterValues.regularPriceEndDate,
      fileUploadDate: this.tableFilterValues.fileUploadDate,
      regularPrices: this.tableFilterValues.regularPrices,
      userName: this.tableFilterValues.userName,
      isActive: !this.showDeletedRows ? true : null,
      groupIds: this.selectGroupIds,
      categoryIds: this.selectCategoryIds,
      subcategoryIds: this.selectSubcategoryIds,
      selectedIds: []
    };
  }

  clearFilters() {
    // Reset all filters
    this.selectSkuName = null;
    this.selectGroupIds = [];
    this.selectCategoryIds = [];
    this.selectSubcategoryIds = [];
    this.selectCodeSalesPoint = null;
    this.selectInternalCode = null;
    this.selectRegionIds = [];
    this.selectStoreIds = [];
    this.selectClusterIds = [];
    this.selectSkuName = null;
    this.selectInternalCode = null;

    // Refetch the data with default filters
    this.fetchFixedPrices(1);
    // this.fetchFilterOptions();
  }

  getDateRange(): string {
    const dateRange = localStorage.getItem('fixedPricesDate');
    return dateRange !== null && this.isDateRangeValid(JSON.parse(dateRange) as string[]) ? dateRange : '';
  }

  isDateRangeValid(dateRange: string[]) {
      return dateRange.length === 2 && moment(dateRange[0]).isValid() && moment(dateRange[1]).isValid()
  }

  changeDateRange(dateRange: string[]) {
      this.dateRange = dateRange;

      if (this.isDateRangeValid(dateRange)) {
          if (this.isRangeNotSelected) this.isRangeNotSelected = false;

          this.fetchFixedPrices(1);
          this.fetchFilterOptions();

          localStorage.setItem('fixedPricesDate', JSON.stringify(dateRange));
      } else {
          this.isRangeNotSelected = true;

          localStorage.removeItem('fixedPricesDate');
      }
  }

  formatDate(date: Date | null): string {
    return date ? moment(date).format("DD.MM.YYYY") : "";
  }

  toggleActiveStatus(row: any, isActive: boolean) {
    const newStatus = !isActive

    const params = {
      id: row.id,
      newStatus: newStatus
    }

    this.httpUpdateActiveStatus(params).then(response => {
      this.showInfo(this.$t('fixedPrices.messages.statusUpdated') as string);

      if (!newStatus) {
          if (this.isCommonCheckboxSelected) {
              const index = this.excludedSkuIds.findIndex(id => id === row.id);

              if (index > -1) this.excludedSkuIds.splice(index, 1);
          } else {
              const index = this.includedSkus.findIndex(sku => sku.id ===  row.id);

              if (index > -1) this.includedSkus.splice(index, 1);
          }
      }
    }).catch(() => {
      this.showError(this.$t('fixedPrices.messages.errorUpdateStatus') as string);
    })
    .finally(() => {
      this.fetchFixedPrices(1);
      // this.fetchFilterOptions();
    });
  }

  handleCommonCheckboxValueChanged(value: boolean) {
      this.includedSkus = [];
      this.excludedSkuIds = [];
  }

  isRowCheckboxChecked(id: number) {
      if (this.isCommonCheckboxSelected) {
          return !this.excludedSkuIds.includes(id);
      } else {
          return this.includedSkus.findIndex(sku => sku.id === id) > -1;
      }
  }

  handleRowCheckboxClicked(item: any, value: boolean) {
      if (this.isCommonCheckboxSelected) {
          if (value) {
              const index = this.excludedSkuIds.findIndex(id => id === item.id)

              if (index > -1) this.excludedSkuIds.splice(index, 1);
          } else {
              this.excludedSkuIds.push(item.id);
          }
      } else {
          if (value) {
              this.includedSkus.push({
                  id: item.id,
                  internalCode: item.internalCode,
                  skuName: item.skuName,
                  storeFormat: item.storeFormat || null,
                  storeRegion: item.storeRegion || null,
                  storeCluster: item.storeCluster || null,
              });
          } else {
              const index = this.includedSkus.findIndex(sku => sku.id === item.id)

              if (index > -1) this.includedSkus.splice(index, 1);
          }
      }
  }

  get isCanStartCalculation() {
      const totalElements = this.showDeletedRows ? this.pagination.totalActiveElements : this.pagination.total

      if (this.isCommonCheckboxSelected) {
          return totalElements > this.excludedSkuIds.length;
      } else {
          return this.includedSkus.length;
      }
  }

  get isEmptyData(): boolean {
    return !this.fixedPricesItems || this.fixedPricesItems.length === 0;
  }


  startCalculationByEndedFixedPriceSkus () {
    this.httpCalcEndedFixedPriceSKUs()
        .then(() => {
          this.showInfo(this.$t('fixedPrices.messages.calcStarted') as string);

          this.$emit('to-results-tab');
        }).catch(() => {
          this.showError(this.$t('fixedPrices.messages.errorStartCalc') as string);
        });
  }

  startCalculationBySelectedSkus () {
      if (this.isStartCalcLoading) return;

      const filters = this.filterParams();
      this.isStartCalcLoading = true;

      this.httpCalcBySelectedSKUs({
          tradingId: this.selectMarket.id,
          isCommonCheckboxSelected: this.isCommonCheckboxSelected,
          included: this.includedSkus,
          excludedIds: this.excludedSkuIds,
          filters: {
              skuName: filters.skuName,
              uploadFileIdFilterValue: filters.uploadFileIdFilterValue,
              codeSalesPoint: filters.codeSalesPoint,
              internalCode: filters.internalCode,
              storeRegionIds: filters.storeRegionIds,
              storeFormatIds: filters.storeFormatIds,
              storeClusterIds: filters.storeClusterIds,
              dateBefore: filters.dateBefore,
              dateAfter: filters.dateAfter,
              regularPriceStartDate: filters.regularPriceStartDate,
              regularPriceEndDate: filters.regularPriceEndDate,
              fileUploadDate: filters.fileUploadDate,
              regularPrices: filters.regularPrices,
          },
      }).then(() => {
          this.showInfo(this.$t('fixedPrices.messages.calcStarted') as string);

          this.$emit('to-results-tab');
      }).catch(() => {
          this.showError(this.$t('fixedPrices.messages.errorStartCalc') as string);
      }).finally(() => {
          this.isStartCalcLoading = false;
      });
  }

    handleFilterAllCheckboxChanged(value: boolean, filterModel: 'regularPrices', filterOptionsKey: string, useRange: boolean = false) {
        this.filterAllCheckboxCheckedState[filterModel] = value;

        if (value) {
            this.tableFilterValues[filterModel] = [
                ...new Set([
                    ...(this.tableFilterValues[filterModel] as number[] || []),
                    ...(this.getFilterOptions(filterModel, filterOptionsKey, useRange) as Array<SelectBox<number>>).map((option: SelectBox<number>) => option.value),
                ])
            ];
        } else {
            const optionValuesToDeselect = (this.getFilterOptions(filterModel, filterOptionsKey, useRange) as Array<SelectBox<number>>).map((option: SelectBox<number>) => option.value);

            this.tableFilterValues[filterModel] = (this.tableFilterValues[filterModel] as number[] || []).filter((value: number) => !optionValuesToDeselect.includes(value));
        }
    }

    getFilterOptions(filterModel: string, filterOptionsKey: string, useRange: boolean = false) {
        if (useRange) {
            return this.tableFilterOptions[filterOptionsKey].filter((option: SelectBox<number>) => {
                if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && !(this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                    return option.value >= this.filterDropdownsRange.from[filterModel];
                } else if (!(this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                    return option.value <= this.filterDropdownsRange.to[filterModel];
                } else if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                    return this.filterDropdownsRange.from[filterModel] <= option.value && option.value <= this.filterDropdownsRange.to[filterModel];
                } else {
                    return true;
                }
            })
        } else {
            return this.tableFilterOptions[filterOptionsKey];
        }
    }
}
